import * as React from "react";
import {
  DataGridPro,
  DataGridProProps,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { cn } from "../../lib/utils";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardAction,
} from "../ui/card";

type DataGridCardProps = {
  title?: string | React.ReactNode;
  action?: React.ReactNode;
  dataGridProps: DataGridProProps;
  className?: string;
};

export const DataGridCard = ({
  dataGridProps: {
    sx: dataGridSx,
    slotProps,
    slots,
    apiRef: externalApiRef,
    ...dataGridProps
  },
  title,
  action,
  className,
}: DataGridCardProps): React.ReactElement => {
  const internalApiRef = useGridApiRef();
  const apiRef = externalApiRef || internalApiRef;

  return (
    <Card className={cn("overflow-hidden", className)}>
      {(title || action) && (
        <CardHeader>
          {title && <CardTitle>{title}</CardTitle>}
          {action && <CardAction>{action}</CardAction>}
        </CardHeader>
      )}
      <CardContent className="pl-2 pr-4">
        <DataGridPro
          apiRef={apiRef}
          {...dataGridProps}
          slots={{
            ...slots,
          }}
          slotProps={{
            ...slotProps,
          }}
          sx={{
            border: "unset",
            borderRadius: 0,
            "& .MuiDataGrid-main": {
              borderRadius: 0,
            },
            "& .MuiDataGrid-columnHeaders": {
              borderRadius: 0,
              borderBottom: "1px solid",
              borderBottomColor: "var(--border)",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid",
              borderTopColor: "var(--border)",
            },
            "& .MuiDataGrid-cell": {
              borderBottomColor: "var(--border)",
            },
            "& .MuiDataGrid-row": {
              "&:hover": {
                backgroundColor: "var(--offwhite)",
              },
              "&.Mui-selected": {
                backgroundColor: "var(--primary-muted)",
                "&:hover": {
                  backgroundColor: "var(--primary-muted)",
                },
              },
            },
            ...dataGridSx,
          }}
        />
      </CardContent>
    </Card>
  );
};

export type { DataGridCardProps };
